import styled from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const MsgAjuda = styled.div`
  margin: 2px;
  font-size: 0.8rem;
  font-weight: 500;
  color: ${COLOR.AZUL};
  min-height: 15px;
`;

export default MsgAjuda;
